module.exports = __webpack_public_path__ + "static/media/01A.39a976b5.png";